import { FirestoreBuildingView } from '../kantoordag/buildingsStreamingApi.ts';
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface BuildingState {
    building: FirestoreBuildingView | undefined
}

const initialState: BuildingState = {
    building: undefined
}

export const buildingSlice = createSlice({
    name: 'building',
    initialState,
    reducers: (create) => ({
        selectBuilding: create.reducer((state, action: PayloadAction<FirestoreBuildingView>) => {
            state.building = action.payload
        }),
    })
})

export const { selectBuilding } = buildingSlice.actions
export default buildingSlice.reducer
